import { useEffect, useState } from "react";
import { Loader2, Shuffle } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { PageHeader, Panel } from "@/components/crm/Badges";

export default function RulesPage() {
  const [rules, setRules] = useState(null);
  const [part, setPart] = useState({});
  const [enabled, setEnabled] = useState(true);

  const apply = (data) => {
    setRules(data);
    setEnabled(data.round_robin_enabled);
    setPart(Object.fromEntries(data.sellers.map((s) => [s.id, s.participates_in_rr])));
  };
  useEffect(() => { api.get("/admin/assignment-rules").then((r) => apply(r.data)); }, []);
  if (!rules) return <Loader2 className="h-6 w-6 animate-spin text-[#1E6FD9]" />;

  const save = async () => {
    try {
      const { data } = await api.put("/admin/assignment-rules", { round_robin_enabled: enabled, participation: part });
      apply(data);
      toast.success("Reglas de asignación guardadas");
    } catch (e) { toast.error(errorMessage(e)); }
  };

  return (
    <div data-testid="rules-page">
      <PageHeader title="Reglas de asignación" subtitle="Se aplican al siguiente lead nuevo">
        <Button onClick={save} className="rounded-xl bg-[#1E6FD9]" data-testid="rules-save-button">Guardar</Button>
      </PageHeader>
      <div className="grid gap-6 lg:grid-cols-3">
        <Panel title="Round Robin" icon={Shuffle}>
          <label className="flex items-center justify-between rounded-xl bg-[#F5F7FA] p-4 text-sm font-medium">
            Asignación automática <Switch checked={enabled} onCheckedChange={setEnabled} data-testid="rr-enabled-switch" />
          </label>
          <p className="mt-3 text-xs text-slate-500">Los leads nuevos se reparten en orden fijo entre vendedores activos que participan. Si no hay ninguno, quedan "Sin asignar".</p>
        </Panel>
        <Panel title="Participación de vendedores" className="lg:col-span-2">
          <ul className="divide-y divide-slate-100" data-testid="rr-sellers-list">
            {rules.sellers.map((s) => (
              <li key={s.id} className="flex items-center justify-between gap-4 py-3" data-testid={`rr-seller-${s.email}`}>
                <div className="flex items-center gap-3">
                  <span className="grid h-8 w-8 place-items-center rounded-lg bg-[#1E6FD9]/10 text-xs font-bold text-[#1E6FD9]">{s.rr_order}</span>
                  <div>
                    <p className="text-sm font-semibold">{s.name}
                      {rules.last_seller_id === s.id && <span className="ml-2 rounded-full bg-[#14B8A6]/10 px-2 py-0.5 text-[11px] font-medium text-[#0f8f81]">Último asignado</span>}
                    </p>
                    <p className="text-xs text-slate-500">{s.email} · {s.active ? "Activo" : <span className="text-rose-600">Desactivado</span>}</p>
                  </div>
                </div>
                <Switch checked={!!part[s.id]} onCheckedChange={(val) => setPart((p) => ({ ...p, [s.id]: val }))} data-testid={`rr-participation-${s.email}`} />
              </li>
            ))}
          </ul>
        </Panel>
      </div>
    </div>
  );
}
